// internal
import { axios, def, storage, handleError, authencated } from './internal';

function IsAuth(configHash, setLoading) {
    axios
        .post('/api/isauth', {
            configHash,
        })
        .then((res) => {
            setLoading(false);
            authencated(res.data.data);
        })
        .catch((err) => {
            setLoading(false);
            const { status, data } = err.response || {};
            switch (status) {
                case def.StatusCodes.UNAUTHORIZED:
                    storage.transience.setState('path.gateway', 'login');
                    break;
                case def.StatusCodes.FORBIDDEN:
                    switch (data?.code) {
                        case def.ErrorCode.AUTH_BANNED_USER:
                            storage.transience.setState({
                                'path.gateway': 'unauthorized',
                                'internal.blocked': new Date(data.data?.expire),
                            });
                            break;
                        case def.ErrorCode.AUTH_INACTIVE_USER:
                            storage.transience.setState({
                                'path.gateway': 'unauthorized',
                                'internal.inactive': true,
                            });
                            break;
                        case def.ErrorCode.AUTH_NOT_VERIFIED:
                            storage.transience.setState({
                                'path.gateway': 'signup-verify-email',
                                'signup.email': data.data?.email,
                            });
                            break;
                        case def.ErrorCode.AUTH_INSUFFICIENT_PERMISSION:
                            storage.transience.setState({
                                'path.gateway': 'unauthorized',
                                'internal.error': 'You do not have permission to access this page.',
                            });
                            break;
                        default:
                        // 기타 403 처리
                    }
                    break;
                case def.StatusCodes.TOO_MANY_REQUESTS:
                    // 레이트리밋 UI/토스트 + 재시도 버튼
                    break;
                case def.StatusCodes.SERVICE_UNAVAILABLE:
                    if (data?.code === def.ErrorCode.AUTH_SERVER_MAINTENANCE) {
                        storage.transience.setState('path.gateway', 'maintenance');
                    } else {
                        storage.transience.setState('path.gateway', 'commingsoon');
                    }
                    break;
                case def.StatusCodes.NOT_FOUND:
                    // SIGNUP_USER_NOT_EXISTS 등
                    break;
                default:
                    handleError(err);
                    break;
            }
        })
        .finally(() => {});
}

export { IsAuth };
